import { render, staticRenderFns } from "./resourceUsage.vue?vue&type=template&id=580ac4c3&"
import script from "./resourceUsage.vue?vue&type=script&lang=js&"
export * from "./resourceUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports